import {configureStore, createSlice}  from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist';
import persistStore from 'redux-persist/es/persistStore';
import storage from 'redux-persist/lib/storage';
const initialState = {
    isAuthenticate: false,
    isCognitoAuthenticated: false,
    cognitoToken: null,
    foundryToken: null,
    cognitoExpiry: null,
    foundryExpiry: null,
    typeOfLogin: null
}
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        cognitoLoginSuccess: (state, action) => {
            const { token, timeout } = action.payload;
            state.cognitoToken = token;
            state.isCognitoAuthenticated = true;
            state.cognitoExpiry = timeout;
        },
        loginSuccess: (state, action) => {
            const { token, timeout, typeOfLogin } = action.payload;
            state.foundryToken = token;
            state.foundryExpiry = timeout;
            state.isAuthenticate = true;
            state.typeOfLogin = typeOfLogin;
        },
        logout: (state) => {
            Object.assign(state, initialState);
        }
    }
});
export const {cognitoLoginSuccess, loginSuccess, logout} = authSlice.actions;
// const authReducer = (state = initialState, action) => {
//     switch(action.type) {
//         case 'COGNITO_LOGIN_SUCCESS':
//             return { ...state, isCognitoAuthenticated: true, cognitoToken: action.payload.token,  cognitoExpiry: action.payload.timeout};
//         case 'LOGIN_SUCCESS':
//             return { ...state, isCognitoAuthenticated: true, cognitoToken: action.payload.token,  cognitoExpiry: action.payload.timeout,  typeOfLogin: action.payload.typeOfLogin};
//         case 'LOGOUT':
//             return initialState;
//         default:
//             return state;
//     }
// }
const persistConfig = {
    key: 'root',
    storage
}
const persistedReducer = persistReducer(persistConfig, authSlice.reducer)
const rootReducer = {
    auth: persistedReducer
};

const AuthStore = configureStore({
    reducer: rootReducer
})
export const Persistor = persistStore(AuthStore)

export default AuthStore;
